import React from 'react'
import styled from 'styled-components'

const TableRowElement = styled.tr`
  height: 0;
  cursor: ${({ onClick, $isClickable }) =>
    onClick && $isClickable && 'pointer'};
`

export const TableRow = ({ onClick, children, isClickable = false }) => (
    <TableRowElement
        className="table-row"
        onClick={onClick}
        $isClickable={isClickable}
    >
        {children}
    </TableRowElement>
)